<template>
  <div
    class="emoji-box sentinel-box"
    tabindex="0"
  >
    <button
      v-for="(icon, index) in ratingsIcon"
      :key="icon.id"
      :disabled="disabled" 
      class="emoji-btn tab-focused-btn"
      :aria-label="icon.label"
      aria-pressed="false"
      @click.stop="(event) => onRatingClick(event, index)"
    >
      <div
        class="ratings"
        :class="{'ratings-selected': selected, 'ratings-btn-disabled': disabled, 'ratings-filled': index === emojiClickedIndex}"
      >
        <BaseIcon
          :name="icon.val"
          height="32px"
          width="32px"
          :fill="icon.color"
        />
      </div>
    </button>
  </div>
</template>
<script>
  import BaseIcon from '@/views/BaseIcon.vue';
  import { COLORS, DEFAULT_RATING } from '../../constant';
  import cloneDeep from 'lodash/cloneDeep'

  export default {
    name: 'EmojiRating',
    components: {
      BaseIcon,
    },
    props: {
      ratingChanged: {
        type: Function,
        default: () => {},
      },
      schema: {
        type: Object,
        default: () => {},
      },
      selected: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        ratingsIcon: cloneDeep(DEFAULT_RATING),
        emojiClickedIndex: -1
      }
    },
    watch: {
      schema() {
        this.ratingsIcon = cloneDeep(DEFAULT_RATING)
      },
    },
    methods: {
      onRatingClick(event, index) {
        this.ratingsIcon = this.ratingsIcon.map((rating, currentIndex) => {
          if (currentIndex === index) {
            rating.color = COLORS.EMOJI_FILLED[rating.val]
            this.emojiClickedIndex = index
          } else {
            rating.color = COLORS.EMOJI
          }
          return rating
        });
        let node = event.target
        while (node?.tagName !== 'BUTTON') node = node?.parentNode
        if (node) node.attributes['aria-pressed'].nodeValue = true
        this.ratingChanged(index + 1);
      },
    },
  };
</script>
<style lang="scss" scoped>
  .emoji-box {
    display: flex;
    gap: 32px;
    
    .emoji-btn {
      border: none;
      background: none;
      .ratings {
        cursor: pointer;
        height: 48px;
        width: 48px;
        background-color: #FAFAFA;
        align-content: center;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        &.ratings-btn-disabled {
          cursor: not-allowed;
        }
        &.ratings-selected {
          border: 1px solid#CDCDCD;
          background: #FFF;
        }
        &:not(.ratings-filled) {
          border: none;
        } 
      }
    }
  }
</style>
